import { render, staticRenderFns } from "./BannerThreeColumnFullWidth.vue?vue&type=template&id=0b891ffd&"
import script from "./BannerThreeColumnFullWidth.vue?vue&type=script&lang=js&"
export * from "./BannerThreeColumnFullWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports